import { HTMLAttributes } from 'react';

export enum AScrimGradientDirection {
  BottomToTop = 'BottomToTop',
  TopToBottom = 'TopToBottom',
  LeftToRight = 'LeftToRight',
  RightToLeft = 'RightToLeft',
}

export interface AScrimGradientProps extends Omit<HTMLAttributes<HTMLDivElement>, 'aria-hidden' | 'role'> {
  direction?: AScrimGradientDirection;
}
